export default __webpack_public_path__ + "static/media/CNo.86-5.a678f899.jpg";